import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {TABLES} from '../../../../../Apis/Tables';
import {GetExtraOrders} from '../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi';
import {FOODIE_REQUEST} from '../Model/Model';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {
    DetailsIconsOptions,
    IconAvatarTable,
    IconScheduleTable,
    NextIconsOptions
} from "../../../../../components/buttons/IconButtons";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat, getFullName} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {userType} from "../../../../../enums/userTypeEnum";
import {colors} from "../../../../../enums/colors";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import {TABS_FOODIE} from "../../Model/Models";
import TableFunction from "../../../../../components/table/TableFunction";
import {CRITERIA_MODEL, DEFAULT_LEFT, SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters} from "../../../../../reduxToolkit/Search/SearchApi";
import CustomTooltip from '../../../../../components/CustomTooltip';


/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const HistoryTableApp = ({
                             setItemSelected,
                             setSummaryModalShow,
                             modified,
                             setModified,
                             searchElement,
                             setBodyForExport,
                             option,
                             setCriteria,
                             finalArray
}) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { user, permission} = useSelector((state) => state.authenticatioauthennSlice);
    const userId = user?.data?.id;
    const [searchResults, setSearchResults] = useState({content: [], totalElements: 0});// Stores API results for history
    const tableId = 'tbl_ht_request_meals';
    const searchId = 'txt_ht_search_request_meals';
    const leftPosition = DEFAULT_LEFT;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes='first_head'>
                {t('request_by')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('user_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('serving_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('service_time')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('approval_status')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = searchResults?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={'first-column'}>
                        <div className={"d-flex align-items-center"}>
                            <div>
                                <IconAvatarTable className={"mr-8px mb-1"} />
                            </div>
                            <CustomTooltip
                            text={getFullName(item?.userName, item?.userLastName, item?.userSecondLastName)}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis`}
                            showIfTruncated={true}
                        />
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            legend={userType[item?.userTypeId] ? t(userType[item?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            background={colors.secondary100}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex align-items-center"}>
                            <div><IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {item?.createdAt ? getDateFormat(item.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex align-items-center"}>
                            <div><IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"}/></div>
                            {item?.servingDate
                                ? getDateFormat(item.servingDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                : EMPTY_VALUES.DEFAULT}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        { item?.mealTimeName ?
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={item?.mealTimeName}
                                variant={'compact'}
                            />
                            :
                            EMPTY_VALUES.DEFAULT
                        }
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.approvalStatusId]}
                            fontColor={statusFontColor[item?.approvalStatusId]}
                            borderColor={statusBorderColor[item?.approvalStatusId]}
                            legend={t(status[item?.approvalStatusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content,
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions/>}
                        click={() => {
                            setItemSelected(item);
                            setSummaryModalShow(true);
                        }}
                    />
                    {(DEV || (permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_UPDATE) && permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_READ)))
                    && item?.approvalFlowId
                    && (
                        <DropDownMenuItem
                            handleClose={handleClose}
                            id={'btn_ht_approval-tracker' + item.id}
                            index={index}
                            name={t('approval_tracker')}
                            url={{
                                pathname: routes.approvalTracker.details + TABLES.FOODIE_REQUEST + '/' + item?.id + '/' + item?.approvalFlowId
                                ,
                                state: {
                                    backUrl: {
                                        pathname: routes.foodie.list,
                                        state: {currentTab: TABS_FOODIE.REQUESTS.INDEX}
                                    }
                                }
                            }}
                            icon={<NextIconsOptions fontSize='medium'/>}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const body = {
            currentDate: Date.now(),
            searchType: FOODIE_REQUEST.HISTORY_ACTIVE,
            key: searchElement,
            pagination: {
                page: page,
                size: rowsPerPage,
            },
        };
        setBodyForExport({
            ...body,
            model: option,
            userId: userId
        });
        dispatch(GetExtraOrders(body))
            .then(({
                       payload: {
                           data: {data, success},
                       },
                   }) => {
                if (success === true) {
                    setSearchResults(data.value);
                }
            });
    };

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size:rowsPerPage,
            model:option,
            rootGroup: CRITERIA_MODEL.set(finalArray)
        });
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(({ payload: {data: { data }}}) => {
            setSearchResults(data);
        });
    }

    /**
     * Destructures the return values from the TableFunction.
     */
    const {
        t,
        thead,
        tbody,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage,
    } = TableFunction({
        data: searchResults,
        labelRowsPerPage: 'request_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,

        rowsPerPage,
        results: searchResults,
        setResults: setSearchResults,
        getData
    };
};

export default HistoryTableApp;
